<template>
  <div class="user">
    <el-dialog title="添加用户" :visible.sync="outerVisible">
      <el-row :gutter="0">
        <el-form
          ref="addUser"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="24">
            <el-form-item label="用户名" prop="name">
              <el-input
                v-model="formData.name"
                placeholder="请输入用户名(不能为空）"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <el-input
                placeholder="请输入密码"
                v-model="formData.password"
                show-password
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUserComfirm('addUser')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改用户" :visible.sync="editVisible">
      <el-row :gutter="0">
        <el-form
          ref="editUser"
          :model="editformData"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="24">
            <el-form-item label="用户名" prop="name">
              <el-input
                v-model="editformData.name"
                placeholder="请输入用户名(不能为空）"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="24">-->
<!--            <el-form-item label="邮箱" prop="email">-->
<!--              <el-input-->
<!--                v-model="editformData.email"-->
<!--                placeholder="请输入邮箱"-->
<!--                clearable-->
<!--              ></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-form>
      </el-row>
      <el-dialog
        width="30%"
        title="添加密码"
        :visible.sync="innerVisible"
        append-to-body>
        <el-form>
          <el-form-item label="添加用户密码" label-width="120px">
            <el-input placeholder="请输入密码" v-model="password" show-password></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submit">确 定</el-button>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserComfirm('editUser')">确 定</el-button>
      </div>
    </el-dialog>
    <el-card>
      <div class="function clearfix">
        <div class="fl search">
          <el-input placeholder="根据用户查询" v-model="username">
<!--            <el-select-->
<!--              v-model="select"-->
<!--              class="input-with-select"-->
<!--              slot="prepend"-->
<!--              placeholder="请选择"-->
<!--            >-->
<!--              <el-option label="餐厅名" value="1"></el-option>-->
<!--              <el-option label="订单号" value="2"></el-option>-->
<!--              <el-option label="用户电话" value="3"></el-option>-->
<!--            </el-select>-->
            <el-button slot="append" icon="el-icon-search" @click="getSearch"></el-button>
          </el-input>
        </div>
        <div class="fr bnt">
          <el-button  type="success" @click="addUser">添加用户</el-button>
        </div>
      </div>
      <el-table :data="usersData" border :stripe="true" style="width: 100%" max-height="600">
<!--        <el-table-column prop="id" label="ID"> </el-table-column>-->
        <el-table-column prop="name" label="用户名"> </el-table-column>
<!--        <el-table-column prop="email" label="邮箱"> </el-table-column>-->
        <el-table-column prop="created_at" label="创建日期"> </el-table-column>
        <el-table-column prop="updated_at" label="最近更新日期"> </el-table-column>
        <el-table-column width="200">
          <template slot-scope="scope">
            <el-button
              type="success"
              plain
              size="small"
              @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-button
              plain
              type="warning"
              size="small"
              @click="delRemoveUser(scope.$index, scope.row)"
              >移除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-divider content-position="left"><em>已删除的用户</em></el-divider>
    <el-table :data="delUsersList" border :stripe="true" style="width: 100%" max-height="600">
<!--        <el-table-column prop="id" label="ID"> </el-table-column>-->
        <el-table-column prop="name" label="用户名"> </el-table-column>
<!--        <el-table-column prop="email" label="邮箱"> </el-table-column>-->
        <el-table-column prop="created_at" label="创建日期"> </el-table-column>
        <el-table-column prop="updated_at" label="最近更新日期"> </el-table-column>
        <el-table-column width="200">
          <template slot-scope="scope">
            <el-button
              type="success"
              plain
              size="small"
              @click="putRecoverUser(scope.$index, scope.row)"
              >恢复</el-button
            >
            <el-button
              plain
              type="danger"
              size="small"
              @click="delUserSubmit(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      select: "",
      usersData: undefined,
      formData: {
        name: undefined,
        password: undefined,
      },
      password: '',
      editformData: {
        name: undefined,
        email: undefined,
        password: undefined,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入用户名(不能为空）",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码(不能为空）",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: false,
            message: "请输入邮箱(不能为空）",
            trigger: "blur",
          },
        ],
      },
      outerVisible: false, // 修改弹窗
      editVisible: false, // 修改弹窗
      innerVisible: false, // 内弹窗
      delUsersList: [], // 已删除的用户
    };
  },
  created() {
    this.getUser(); // 获取所有用户
    this.delUsersData(); // 获取已删除的用户
  },
  methods: {
    // ----------------------------request---------------start

    // 获取所有用户
    async getUser() {
      const { data: res } = await this.axios.get("/users");
      if (res.meta.status === 200) {
        this.usersData = res.data.users;
      }else{
        this.$message.warning("获取用户失败！！！");
      }
    },
    // 添加用户
    async postUser(data){
      const { data: res } = await this.axios.post("/users", data);
      if(res.meta.status === 201) {
        this.getUser(); // 添加成功后获取用户数据
        return this.$message.success("用户添加成功！！！");
      }else if(res.meta.status === 409){ //用户名已经注册
        this.$message.warning("该用户名已注册，请重新起名！！！");
      }else{
        return this.$message.warning("用户添加失败！！！");
      }
    },
    // 根据用户名模糊查询
    async getSearch(){
      const {data: res } = await this.axios.get("/users", {params: {name: this.username}});
      if(res.meta.status === 200) this.usersData = res.data.users;
      return this.$message.success(res.meta.msg);
    },
    // 修改用户信息
    async putUser(data){
      const {data: res } = await this.axios.put("/users", data);
      if(res.meta.status === 200){
        this.getUser(); // 重新获取用户
        this.innerVisible = false; // 关闭弹窗
        this.editVisible = false; // 关闭弹窗
        return this.$message.success(res.meta.msg);
      }else if(res.meta.status === 409){
        this.innerVisible = false; // 关闭弹窗
        return this.$message.warning("该用户名已存在，请重新输入！！！");
      }else{
        return this.$message.error("请求异常！！！");
      }
    },
    // 移除用户
    async delRemoveUser(index, row) {
      this.$message.info("数据可恢复!!!");
      const {data: res } = await this.axios.delete("/users", {params: {id: row.id}});
      if(res.meta.status === 200) {
        this.getUser(); // 重新获取用户
        this.delUsersData(); // 获取已删除的用户
        return this.$message.success("移除成功！！！");
      }
      if(res.meta.status === 400) return this.$message.warning("该用户不存在！！！");
      return this.$message.error("请求异常！！！");
    },
    // 硬删除
    async delUser(row){
      const {data: res } = await this.axios.delete("/forcedel", {params: {id: row.id}});
      if(res.meta.status === 200) {
        this.delUsersData(); // 获取已删除的用户
        return this.$message.success("删除成功！！！");
      }
      if(res.meta.status === 400) return this.$message.warning("该用户不存在！！！");
      return this.$message.error("请求异常！！！");
    },
    // 查看被软删除的用户
    async delUsersData(){
      const {data: res } = await this.axios.get("/whoisdel");
      this.delUsersList = res.data;
      if(res.meta.status !== 200) return this.$message.error("请求异常！！！");
    },
    // 恢复已删除的用户
    async putRecoverUser(index, row){
      const {data: res } = await this.axios.put("/restoredel", {id: row.id});
      if(res.meta.status === 200) {
        this.getUser(); // 获取所有用户
        this.delUsersData(); // 获取已删除的用户
        return this.$message.success(res.meta.msg);
      }else{
        return this.$message.warning("操作无效！！！");
      }
    },


    // ----------------------------request---------------end
    // 添加用户
    addUser(){
      this.outerVisible = true;
    },
    // 确认添加用户
    addUserComfirm(formName){
      this.$refs[formName].validate((valid) => {
        let data = {
          name: this.formData.name,
          password: this.formData.password,
        };
        if (valid) return this.postUser(data); // 添加用户
        return this.$message.warning("格式有误！！！");
      });
    },
    // 点击修改
    handleEdit(index, row) {
      this.editVisible = true;
      this.editformData = JSON.parse(JSON.stringify(row));
    },
    // 修改信息验证
    editUserComfirm(formName){
      this.$refs[formName].validate((valid) => {
        if(valid) {
          this.innerVisible = true;
        }else{
          this.$message.warning("格式有误！！！");
        }
      })
    },
    // 确认密码后提交
    submit(){
      if(!this.password) return this.$message.warning("密码不能为空！！！");
      let data = {
        id: this.editformData.id,
        name: this.editformData.name,
        password: this.password,
      }
      this.putUser(data); // 修改用户信息
    },
    // 点击删除
    delUserSubmit(index, row){
      this.$alert('该操作将无法恢复数据，是否确定删除？', '确认操作', {
          confirmButtonText: '确定',
          callback: action => {
            if(action === 'confirm'){
              this.delUser(row); // 确定删除用户
            }
          }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.function {
  width: 100%;
  margin: 10px auto;
  .search {
    width: 40%;
    .input-with-select {
      width: 130px;
    }
  }
}
</style>
